export default __webpack_public_path__ + "static/media/pccs.8fc2f5ff.png";